/**
 * 连接层 / UI 访问 SDK 的统一入口。
 * 仅依赖 loader，避免 App 首屏静态拉取 sdkApi 实现模块。
 */
import type { SdkApiType } from "../types/sdkApi";
import { assertSdkApiReady } from "./loader";

export { ensureConnectSdkReady } from "./loader";

export function getSdkApiDefault(): SdkApiType {
  return assertSdkApiReady();
}

export function getServiceKeyboard() {
  return assertSdkApiReady().keyboard.serviceKeyboard!;
}

export function getHfdServiceKeyboard() {
  return assertSdkApiReady().keyboard.hfdServiceKeyboard!;
}

export function getBeiyingKeyboard() {
  return assertSdkApiReady().keyboard.beiyingKeyboard!;
}

export function getBeiyingKeyboardX98_1K_8815() {
  return assertSdkApiReady().keyboard.beiyingKeyboardX98_1K_8815!;
}

export function getBeiyingMachineKeyboard() {
  return assertSdkApiReady().keyboard.beiyingMachineKeyboard!;
}

export function getMouseService() {
  return assertSdkApiReady().mouse.mouseService!;
}

export function getSdkMouseBasicApi() {
  return assertSdkApiReady().mouse.sdkMouseBasicApi;
}

export function clearFreqDeviceComm(stableId?: string) {
  return assertSdkApiReady().mouse.clearFreqDeviceComm!(stableId);
}

export function clearZhanliDeviceComm(stableId?: string) {
  return assertSdkApiReady().mouse.clearZhanliDeviceComm!(stableId);
}

export function getDeviceInfoLocked(
  ...args: Parameters<
    NonNullable<SdkApiType["keyboard"]["getDeviceInfoLocked"]>
  >
) {
  return assertSdkApiReady().keyboard.getDeviceInfoLocked!(...args);
}

export function connectDeviceLocked(
  ...args: Parameters<
    NonNullable<SdkApiType["keyboard"]["connectDeviceLocked"]>
  >
) {
  return assertSdkApiReady().keyboard.connectDeviceLocked!(...args);
}

export function syncBeiying8815SdkKeyLibrary() {
  return assertSdkApiReady().keyboard.syncBeiying8815SdkKeyLibrary!();
}

export function waitForBeiyingHidKeyboardReady() {
  return assertSdkApiReady().keyboard.waitForBeiyingHidKeyboardReady!();
}

export function waitForBeiying8815KeyboardReady() {
  return assertSdkApiReady().keyboard.waitForBeiying8815KeyboardReady!();
}

export function waitForBeiyingMachineSDKReady() {
  return assertSdkApiReady().keyboard.waitForBeiyingMachineSDKReady!();
}

export async function releaseBeiyingPix() {
  const mod = await import("./mouse/beiying/basic");
  return mod.releaseBeiyingPix();
}
